import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

function LeadCaptureModal({ onSubmit }) {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");

  useEffect(() => {
    const hasVisited = localStorage.getItem("leadUser");
    if (!hasVisited) {
      const timer = setTimeout(() => setShowModal(true), 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!agreed) return alert("Please agree to the Terms and Conditions");

    try {
      const res = await fetch("http://localhost:3002/api/leads", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, mobile }),
      });

      if (!res.ok) throw new Error("Failed to submit");

      localStorage.setItem("leadUser", "true");
      setFormSubmitted(true);
      setShowModal(false);
      onSubmit(); // callback to parent
    } catch (err) {
      alert("Error: " + err.message);
    }
  };

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0, 0, 0, 0.4)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem",
  };

  const modalStyle = {
    background: "#fff",
    padding: "1.5rem",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "500px",
    boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    zIndex: 10000,
  };

  const inputStyle = {
    width: "100%",
    padding: "0.8rem",
    fontSize: "1rem",
    borderRadius: "6px",
    border: "1px solid #ccc",
  };

  const buttonStyle = {
    background: "#0066ff",
    color: "#fff",
    padding: "0.75rem 1.2rem",
    border: "none",
    borderRadius: "6px",
    fontSize: "1rem",
    fontWeight: "600",
    width: "100%",
    cursor: "pointer",
  };

  const watermarkStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    fontSize: "4rem",
    color: "rgba(0, 0, 0, 0.03)",
    transform: "translate(-50%, -50%) rotate(-30deg)",
    zIndex: 0,
    whiteSpace: "nowrap",
    pointerEvents: "none",
  };

  return (
    <>
      <AnimatePresence>
        {!formSubmitted && showModal && (
          <motion.div
            style={overlayStyle}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              style={modalStyle}
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 30, opacity: 0 }}
              transition={{ duration: 0.4 }}
            >
              <div style={watermarkStyle}>Kismat Ki Property</div>

              <div style={{ display: "flex", flexDirection: "column", gap: "1rem", zIndex: 1 }}>
                <img
                  src="/assets/logo1.png"
                  alt="Login"
                  style={{ width: "100px", margin: "auto" }}
                />
                <h2 style={{ fontSize: "1.4rem", color: "#111", textAlign: "center" }}>
                  Welcome to Kismat ki Property
                </h2>
                <p style={{ fontSize: "0.95rem", color: "#555", textAlign: "center" }}>
                  Fill this quick form to continue browsing
                </p>
                <form
                  onSubmit={handleSubmit}
                  style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}
                >
                  <input
                    type="text"
                    placeholder="What's your Name"
                    required
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    style={inputStyle}
                  />
                  <input
                    type="tel"
                    placeholder="What's your Mobile Number"
                    required
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    style={inputStyle}
                  />
                  <label style={{ fontSize: "0.85rem", color: "#333", textAlign: "left" }}>
                    <input
                      type="checkbox"
                      checked={agreed}
                      onChange={(e) => setAgreed(e.target.checked)}
                      style={{ marginRight: "0.5rem" }}
                    />
                    I agree to the{" "}
                    <span
                      onClick={() => setShowTerms(true)}
                      style={{ color: "#0066ff", textDecoration: "underline", cursor: "pointer" }}
                    >
                      Terms & Conditions
                    </span>
                  </label>
                  <button type="submit" style={buttonStyle}>
                    Continue
                  </button>
                </form>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Terms Modal */}
      <AnimatePresence>
        {showTerms && (
          <motion.div
            style={{
              ...overlayStyle,
              background: "rgba(0,0,0,0.6)",
              zIndex: 10001,
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowTerms(false)}
          >
            <motion.div
              style={{
                ...modalStyle,
                maxWidth: "600px",
                padding: "1rem",
                maxHeight: "80vh",
                overflowY: "auto",
              }}
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <h3 style={{ marginBottom: "0.5rem" }}>Terms & Conditions</h3>
              <p style={{ fontSize: "0.9rem", color: "#444", lineHeight: "1.5" }}>
                {/* You can paste your full legal terms text here */}
               This website <strong>KismatKiProperty.com</strong>, including any subdomains
                thereof, and any other websites through which its services are made available, our
                mobile, tablet and other smart device applications, and application program
                interfaces etc., (hereinafter collectively referred to as <strong>"KismatKiProperty"</strong>) is owned, hosted and
                operated by <strong>Kismat Ki Property Pvt. Ltd.</strong>, a company incorporated in India under the Companies Act, 1956 and having its registered office at Ground Floor, GF-12A, 94, Meghdoot, Nehru Place, New Delhi - 110 020.
              </p>
              <p style={{ fontSize: "0.9rem", color: "#444", lineHeight: "1.5" }}>
                These terms and conditions, privacy policy and community guidelines regulating use
                of these Services constitute a legally binding agreement between KismatKiProperty
                and the User (the “Agreement”).
              </p>
              <p style={{ fontSize: "0.9rem", color: "#444", lineHeight: "1.5" }}>
                KismatKiProperty and/or any other website(s) linked to this website is an online
                information and communications service provided to you, subject to your compliance
                with the terms and conditions set forth below.
              </p>
              <p style={{ fontSize: "0.9rem", color: "#444", lineHeight: "1.5" }}>
                Kismat Ki Property Pvt. Ltd. may amend/modify these terms and conditions at any
                time, and such modifications shall be effective immediately upon posting of the
                modified terms and conditions on KismatKiProperty. You may review the modified
                terms and conditions periodically to be aware of such modifications and your
                continued access or use of KismatKiProperty shall be deemed conclusive proof of
                your acceptance of these terms and conditions, as amended/modified from time to
                time.
              </p>
              <p style={{ fontSize: "0.9rem", color: "#444", lineHeight: "1.5" }}>
                Kismat Ki Property Pvt. Ltd. may also suspend the operation of KismatKiProperty for
                support or technical upgradation, maintenance work, in order to update the content
                or for any other reason.
              </p>
              <p style={{ fontSize: "0.9rem", color: "#444", lineHeight: "1.5" }}>
                If you utilize KismatKiProperty in a manner inconsistent with these terms and
                conditions, Kismat Ki Property Pvt. Ltd. may terminate your access, block your
                future access and/or seek such additional relief as the circumstances of your misuse
                may be deemed to be fit and proper.
              </p>
              <p style={{ fontSize: "0.9rem", color: "#444", lineHeight: "1.5" }}>
               Content
              We employ proprietary and third-party AI tools to identify and address harmful content on our platform. These tools are designed to take reasonable efforts towards detecting violations of platform terms and applicable laws, including harmful behavior such as speech that violates our platform terms. Automated moderation may operate automatically or with human oversight, depending on the complexity of the content and internal guidelines. Based on the output of technological moderation, content may be approved, rejected, or escalated to a second level of review by human moderators. These tools rely on third-party services to provide the detection and moderation capabilities.
              Our automated tools function as part of a multi-layered moderation process. Please note that users have the right to raise grievances or appeal moderation decisions in accordance with our platform terms [ Grievances ] and such feedback will be reviewed in accordance with established timelines, including by human moderators where necessary.
              These tools are part of our ongoing efforts to improve moderation  capabilities and ensure compliance with legal and platform standards. While we endeavour to maintain accuracy and fairness, no system is perfect. The measures are implemented on an “as is” basis, and we will continue to refine them in collaboration with external service providers to better protect our community.

              </p>
             
              <p style={{ fontSize: "0.9rem", color: "#444", lineHeight: "1.5" }}>
               Payment Terms
              •Payments for the Services offered by KismatKiProperty shall be on a 100% advance basis. The payment for Service once subscribed to by the subscriber is not refundable and any amount paid shall stand appropriated. Refund if any will be at the sole discretion of Info Edge (India) Limited. IEIL offers no guarantees whatsoever for the accuracy or timeliness of the refunds reaching the Users card/bank accounts. User acknowledges and agrees that IEIL/kismatkiproperty.com, at its sole discretion and without prejudice to other rights and remedies that it may have under the applicable laws, shall be entitled to set off the amount paid or payable by a subscriber/user against any amount(s) payable by User to IEIL under any other agreement or commercial relationship towards other products/services. Info Edge (India) Ltd gives no guarantees of server uptime or applications working properly. All is on a best effort basis and liability is limited to refund of amount only. Info Edge (India) Ltd. undertakes no liability for free Services. Info Edge (India) Ltd. reserves its right to amend / alter or change all or any disclaimers or terms of agreements at any time without any prior notice. All terms / disclaimers whether specifically mentioned or not shall be deemed to be included if any reference is made to them.
              •Info Edge (India) Limited uses the maximum care as is possible to ensure that all or any data / information in respect of electronic transfer of money does not fall in the wrong hands. For completing online transactions involving payments a user is directed to a Payment Gateway, Info Edge India Ltd does not store or keep credit card data. Since the transaction happens on a third-party network not controlled by Info Edge India Limited, once a credit card transaction has been completed, the payment information is not accessible to anyone at Info Edge (India) Limited after completion of the on-line transaction at the Payment Gateway, this ensures the maximum security.
              •Info Edge India Limited shall not be liable for any loss or damage sustained by reason of any disclosure (inadvertent or otherwise) of any information concerning the user's account and / or information relating to or regarding online transactions using credit cards / debit cards and / or their verification process and particulars nor for any error, omission or inaccuracy with respect to any information so disclosed and used whether or not in pursuance of a legal process or otherwise.
</p>
<p style={{ fontSize: "0.9rem", color: "#444", lineHeight: "1.5" }}>
                Refund in failed transactions
                Though IEIL payment reconciliation team works on a 24 x 7 basis, IEIL offers no guarantees whatsoever for the accuracy or timeliness of the refunds reaching the Subscribers card/bank accounts. This is on account of the multiplicity of organizations involved in processing of online transactions, the problems with Internet infrastructure currently available and working days/holidays of financial institutions. Refunds in the event of wrong/objectionable property content being posted on the site would be at the discretion of KismatKiProperty.
                If you utilize KismatKiProperty in a manner inconsistent with these terms and conditions, IEIL may terminate your access, block your future access and/or seek such additional relief as the circumstances of your misuse may be deemed to be fit and proper.
              </p>
              <p style={{ fontSize: "0.9rem", color: "#444", lineHeight: "1.5" }}>
                Video Community Guidelines
              •User agrees to comply with the following community guidelines while submitting video content for listings/advertisements:
              •Video should be original, free from any copyright issue
              •Video should not contain any personally identifiable information of the User/Agency
              •Video content should not be obscene/inappropriate
              •Video should not contain language which is detrimental to any community/segment
               Video Content Screening Videos shared by user shall go through multiple stages of screening (human and technology driven) before going live on the platform. In case of violations with the community guidelines, the video content shall be duly removed from the listing.
              •Additionally, the video screening process shall also be carried out in the following cases:
              •User reporting the video to toll free/email ids
               Infringement claim by agent/user
              •The video shall be removed from the platform in case the claim is found to be correct. Final discretion on video screening and removal shall always lie with Platform.
               Agents shall have the option to edit or remove videos during the course of the listing duration.
               kismatkiproperty shall utilize 3rd party services such as You-tube for hosting and streaming these videos. While doing so, the site and the users on the site shall be compliant with respect to You-tube Terms of Service https://www.youtube.com/t/terms and Youtube API Services - Developer Policies.
              </p>
              <p style={{ fontSize: "0.9rem", color: "#444", lineHeight: "1.5" }}>
               Use of Information
               User agrees to treat all information obtained from the Service, including listings, member directory, and any information otherwise made available to User in the Service ("Content") as proprietary to kismatkiproperty. User agrees that Content reserved for members will be
              maintained as confidential and shall be protected as a trade secret of kismatkiproperty. kismatkiproperty does not ensure the accuracy of, endorse or recommend any Content and a User uses such Content at the User's own risk. A User may access the listings/advertisements in the Service solely to obtain initial information from which further evaluation and investigation may commence. User shall limit access to and use of listings to personal and internal use, and shall not use listings obtained from the Service for further distribution, publication, public display, or preparation of derivative works or facilitate any of these activities in any way.
               User shall not use or reproduce any Content that is obtained from the Service, or that is otherwise made available to User in the Service, for or in connection with any other listing/advertising Service or device. User further shall not use the Service provided by the company in any other manner for or in connection with any other listing Service or device. Users violating these specific terms, specifically those Users searching the Service in an abusive or excessive manner, by automated or manual means, shall be subject to immediate termination of their membership without notice.

              </p>
               <p style={{ fontSize: "0.9rem", color: "#444", lineHeight: "1.5" }}>
              Terms of conditions specific for dealers/ builders/ banks/Payment Gateways
              •You will comply with all applicable Data Protection Laws in relation to the Processing of personal data; and not process personal data which is irrelevant, in an unlawful manner and excessive with regard to agreed purposes as defined in the privacy policy and these terms and conditions
              •You shall implement adequate technical and organizational controls to protect the shared personal data obtained from kismatkiproperty against unauthorized or unlawful processing and against accidental loss, destruction, damage, alteration or disclosure
              •You agree to provide reasonable assistance as is necessary to facilitate the handling of any Data Security Breach (as applicable the privacy law as applicable) in an expeditious and compliant manner
              •You agree that the responsibility for complying with a the request of an individual with respect to his/her personal data lies with the Party which holds/processes the personal data collected/shared
              •You warrant and represent that the institution shall not disclose or transfer Personal Data obtained from 99acres to any sub-processors without ensuring that adequate and equivalent safeguards to the Personal Data.
              •You shall retain or process shared personal data for no longer than is necessary to carry out the agreed purposes.
              </p>
               <button
                onClick={() => setShowTerms(false)}
                style={{ ...buttonStyle, marginTop: "1rem", background: "#555" }}
              >
                Close
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default LeadCaptureModal;
